var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/auth_login/components/otp_auth_form.tsx";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import React, { useState } from 'react';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import { otpVerify, verifyCredentials, switchAccount } from 'soapbox/actions/auth';
import { Button, Form, FormActions, FormGroup, Input } from 'soapbox/components/ui';
import { useAppDispatch } from 'soapbox/hooks';
const messages = defineMessages({
  otpCodeHint: {
    "id": "login.fields.otp_code_hint",
    "defaultMessage": "Enter the two-factor code generated by your phone app or use one of your recovery codes"
  },
  otpCodeLabel: {
    "id": "login.fields.otp_code_label",
    "defaultMessage": "Two-factor code:"
  },
  otpLoginFail: {
    "id": "login.otp_log_in.fail",
    "defaultMessage": "Invalid code, please try again."
  }
});
const OtpAuthForm = ({
  mfa_token
}) => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const [isLoading, setIsLoading] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [codeError, setCodeError] = useState('');
  const getFormData = form => Object.fromEntries(Array.from(form).map(i => [i.name, i.value]));
  const handleSubmit = event => {
    const {
      code
    } = getFormData(event.target);
    dispatch(otpVerify(code, mfa_token)).then(({
      access_token
    }) => {
      setCodeError(false);
      return dispatch(verifyCredentials(access_token));
    }).then(account => {
      setShouldRedirect(true);
      return dispatch(switchAccount(account.id));
    }).catch(() => {
      setIsLoading(false);
      setCodeError(true);
    });
    setIsLoading(true);
    event.preventDefault();
  };
  if (shouldRedirect) return /*#__PURE__*/React.createElement(Redirect, {
    to: "/",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 30
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-600 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "login.otp_log_in",
    defaultMessage: "OTP Login",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: intl.formatMessage(messages.otpCodeLabel),
    hintText: intl.formatMessage(messages.otpCodeHint),
    errors: codeError ? [intl.formatMessage(messages.otpLoginFail)] : [],
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    name: "code",
    type: "text",
    autoComplete: "off",
    autoFocus: true,
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(FormActions, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    type: "submit",
    disabled: isLoading,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "login.sign_in",
    defaultMessage: "Sign in",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 79,
      columnNumber: 15
    }
  }))))));
};
export default OtpAuthForm;